import { render, staticRenderFns } from "./filter-card.vue?vue&type=template&id=23fc657d&"
import script from "./filter-card.vue?vue&type=script&lang=js&"
export * from "./filter-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports